import React from "react";
import { X, FileText, Truck, UserRound } from "lucide-react";

function formatDateAR(value) {
  if (!value) return "-";
  const s = String(value).slice(0, 10);
  const [y, m, d] = s.split("-");
  if (!y || !m || !d) return "-";
  return `${d}/${m}/${y}`;
}

export default function ReadyToInvoiceModal({
  open,
  offers = [],
  onClose,
  onOpenOffer,
  onOpenService,
  onMarkInvoiced,
}) {
  if (!open) return null;

  return (
    <div
      className="fixed inset-0 z-[90] bg-black/70 grid place-items-center p-4"
      onMouseDown={(e) => e.target === e.currentTarget && onClose?.()}
    >
      <div
        className="w-full max-w-4xl max-h-[88vh] overflow-hidden rounded-2xl border border-white/10 bg-[#111318] text-white shadow-2xl flex flex-col"
        onMouseDown={(e) => e.stopPropagation()}
      >
        <div className="flex items-center justify-between px-5 py-4 border-b border-white/10">
          <div>
            <h3 className="text-lg font-semibold">Ofertas listas para facturar</h3>
            <p className="text-xs text-white/60">
              {offers.length} oferta{offers.length === 1 ? "" : "s"} lista{offers.length === 1 ? "" : "s"} para facturar
            </p>
          </div>

          <div className="flex items-center gap-2">
            <button
              className="inline-flex items-center gap-2 rounded-md border border-white/10 px-3 py-1.5 hover:bg-white/10"
              onClick={onClose}
            >
              <X className="h-4 w-4" />
              Cerrar
            </button>
          </div>
        </div>

        <div className="flex-1 overflow-y-auto p-5">
          {offers.length === 0 ? (
            <div className="rounded-lg border border-white/10 bg-white/5 p-4 text-sm text-white/70">
              No hay ofertas listas para facturar.
            </div>
          ) : (
            <div className="space-y-3">
              {offers.map((item) => {
                const remitoLabel = item.remito
                  ? item.remito.official_number || item.remito.code || "-"
                  : "-";

                return (
                  <div
                    key={item.offer.id}
                    className="rounded-xl border border-amber-400/30 bg-amber-500/10 p-4"
                  >
                    <div className="flex flex-col gap-3 lg:flex-row lg:items-center lg:justify-between">
                      <div className="space-y-1">
                        <div className="flex items-center gap-2 text-sm font-semibold">
                          <FileText className="h-4 w-4" />
                          Oferta {item.offer.code || item.offer.base_number || "-"}
                          <span className="rounded-full border border-amber-400/40 bg-amber-500/20 px-2 py-0.5 text-[11px] text-amber-50">
                            Lista para facturar
                          </span>
                        </div>
                        <div className="flex items-center gap-2 text-sm text-white/75">
                          <UserRound className="h-4 w-4 text-white/50" />
                          {item.offer.client?.name || "-"}
                        </div>
                        <div className="flex flex-wrap gap-x-4 gap-y-1 text-xs text-white/60">
                          <span>OS: {item.os?.code || "-"}</span>
                          <span>Remito: {remitoLabel}</span>
                          <span>Fecha: {formatDateAR(item.remito?.date_out)}</span>
                        </div>
                      </div>

                      <div className="flex flex-wrap gap-2">
                        <button
                          type="button"
                          className="rounded-md border border-white/15 bg-white/10 px-3 py-2 text-sm hover:bg-white/15"
                          onClick={() => onOpenOffer?.(item.offer)}
                        >
                          Ver oferta
                        </button>
                        <button
                          type="button"
                          className="rounded-md border border-amber-500/30 bg-amber-500/10 px-3 py-2 text-sm text-amber-100 hover:bg-amber-500/15"
                          onClick={() => onOpenService?.(item.offer)}
                        >
                          Ir a facturar
                        </button>
                        <button
                          type="button"
                          className="rounded-md border border-emerald-500/30 bg-emerald-500/15 px-3 py-2 text-sm text-emerald-50 hover:bg-emerald-500/25"
                          onClick={() => onMarkInvoiced?.(item.offer?.id)}
                        >
                          Marcar como facturado
                        </button>
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
